export default "{\n  \"schemaVersion\": 2,\n  \"components\": [],\n  \"type\": \"default\",\n  \"id\": \"Form_0\"\n}\n"